import React from 'react';

import { JiraIcon } from '@atlaskit/logo/jira-icon';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration, GlobalShortcutLinkItem } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';
import { messages } from './messages';

const icon = <JiraIcon size="xsmall" label="" />;

export const useJira = (
	fallbackUrl: FallbackUrl,
	options: GlobalShortcutConfiguration = {},
): GlobalShortcutLinkItem =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.JIRA_SOFTWARE,
		analyticsName: Products.JIRA_SOFTWARE,
		...options,
	});
